export enum UserType {ADMIN = "administrador", SUPERVISOR = "supervisor", VALET = "valet"}
export default interface UserEntity {
    id: string;
    name: string;
    prefix: string;
    phone: string;
    username: string;
    role: UserType;
    document: string;
    documentType: string;
    email: string;
}
